import { FlexBox } from "components/Common/FlexBox"
import ErrorMessage from "components/ErrorMessage"

const BodyErrors = ({
  heightError,
  weightError,
}: {
  heightError: string
  weightError: string
}) => {
  if (!heightError && !weightError) {
    return null
  }

  return (
    <FlexBox $direction="column" $gap={8} style={{ padding: "16px 0" }}>
      {heightError && (
        <ErrorMessage title="Invalid height" content={heightError} />
      )}

      {weightError && (
        <ErrorMessage title="Invalid weight" content={weightError} />
      )}
    </FlexBox>
  )
}

export default BodyErrors
